var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArticles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.27 17.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.71px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.05,4.29,10,.22A.75.75,0,0,0,9.45,0H1.13A1.12,1.12,0,0,0,0,1.13v15a1.13,1.13,0,0,0,1.13,1.13h12a1.13,1.13,0,0,0,1.13-1.13V4.82A.75.75,0,0,0,14.05,4.29ZM10.14,1.44l2.69,2.69H10.52a.38.38,0,0,1-.38-.37Zm3,15.08h-12a.37.37,0,0,1-.38-.37v-15A.38.38,0,0,1,1.13.75H9.39v3a1.12,1.12,0,0,0,1.13,1.12h3V16.15A.37.37,0,0,1,13.14,16.52Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2.64,
    y1: 2.94,
    x2: 7.58,
    y2: 2.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2.64,
    y1: 5.77,
    x2: 8.28,
    y2: 5.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2.64,
    y1: 11.42,
    x2: 11.68,
    y2: 11.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2.64,
    y1: 8.59,
    x2: 11.68,
    y2: 8.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2.64,
    y1: 14.24,
    x2: 11.68,
    y2: 14.24
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticles);
export default __webpack_public_path__ + "static/media/articles.d3c4c3dbe8444e51635eab8136670244.svg";
export { ForwardRef as ReactComponent };